export const serviceAccountMiddlewares = [
  // (data) => {
  //   return data.filter((e) => !e.ProcyonInternal)
  // }
]
